import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginAdmin } from '../../utils/api';
import toast, { Toaster } from 'react-hot-toast';
import { FaLock, FaUser } from 'react-icons/fa';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
        const data = await loginAdmin(email, password);
        // Save token to localStorage
        localStorage.setItem('adminToken', data.access_token);
        toast.success("Welcome back, Admin!");
        setTimeout(() => navigate('/admin/products'), 1000);
    } catch (error) {
        console.error(error);
        toast.error("Invalid credentials. Please try again.");
    } finally {
        setLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      <Toaster position="top-center" />
      <div className="login-card">
        <h2>Audiopine Admin</h2>
        <p>Secure Dashboard Access</p>
        
        <form onSubmit={handleLogin}>
          <div className="input-group">
            <FaUser className="icon" />
            <input 
                type="text" 
                placeholder="Admin Email/Username" 
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
            />
          </div>
          <div className="input-group">
            <FaLock className="icon" />
            <input 
                type="password" 
                placeholder="Password" 
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
            />
          </div>
          <button type="submit" disabled={loading} className="login-btn">
            {loading ? "Authenticating..." : "Login to Dashboard"}
          </button>
        </form>
      </div>

      <style>{`
        .admin-login-page {
            height: 100vh;
            background-color: #0c0c0c;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            font-family: 'Segoe UI', sans-serif;
        }
        .login-card {
            background: #18181b;
            padding: 40px;
            border-radius: 12px;
            border: 1px solid #27272a;
            width: 100%;
            max-width: 400px;
            text-align: center;
        }
        .login-card h2 { color: #10b981; margin-bottom: 10px; }
        .login-card p { color: #9ca3af; margin-bottom: 30px; }
        .input-group {
            background: #000;
            border: 1px solid #333;
            border-radius: 6px;
            display: flex;
            align-items: center;
            padding: 0 15px;
            margin-bottom: 15px;
        }
        .input-group .icon { color: #6b7280; }
        .input-group input {
            background: none;
            border: none;
            width: 100%;
            padding: 15px;
            color: white;
            outline: none;
        }
        .login-btn {
            width: 100%;
            background: #10b981;
            color: white;
            border: none;
            padding: 15px;
            border-radius: 6px;
            font-weight: bold;
            cursor: pointer;
            transition: 0.3s;
        }
        .login-btn:hover { background: #059669; }
        .login-btn:disabled { background: #333; cursor: not-allowed; }
      `}</style>
    </div>
  );
};

export default AdminLogin;